export default class Node {
	constructor(name) {
		this.name = name;
		this.transitions = [];
	}

	addTransition(Transition) {
		this.transitions.push(Transition);
	}
}
